import { infoFetchEstadoI, makeEstado } from "dtos/estado";
import { infoFetchGetRolesI, makeRol } from "dtos/roles";
import { infoFetchTipoEfectoI, makeTipoEfecto } from "dtos/tipoEfecto";
import { ENDPOINTS } from "./endpoints";
import { fetchingPropsI } from "./request/request.interface";
import { sendRequest } from "./request/request.service";
import { servicesUtils } from "./utils/services.utils";
import { AlcanceI } from "interfaces/Alcance";
import { infoFetchTipoNormativaI, makeTipoNormativa } from "dtos/tipoNormativa";

export const getTiposResoluciones = async ({
  params,
  signal,
}: fetchingPropsI) => {
  const response = await sendRequest<infoFetchTipoNormativaI[]>({
    method: "GET",
    uri: ENDPOINTS.TIPO_NORMATIVA,
    params: servicesUtils.removeNullParamsInFilters(params),
    signal,
  });
  return response.map((ctElemento) => makeTipoNormativa(ctElemento));
};

export const getTiposEfecto = async ({ params, signal }: fetchingPropsI) => {
  const response = await sendRequest<infoFetchTipoEfectoI[]>({
    method: "GET",
    uri: ENDPOINTS.TIPO_EFECTO,
    params: servicesUtils.removeNullParamsInFilters(params),
    signal,
  });
  return response.map((ctElemento) => makeTipoEfecto(ctElemento));
};

export const getRoles = async ({ params, signal }: fetchingPropsI) => {
  const response = await sendRequest<infoFetchGetRolesI[]>({
    method: "GET",
    uri: ENDPOINTS.AUTH + "/roles",
    params: servicesUtils.removeNullParamsInFilters(params),
    signal,
  });
  return response.map((ctElemento) => makeRol(ctElemento));
};

export const getEstados = async ({ params, signal }: fetchingPropsI) => {
  const response = await sendRequest<infoFetchEstadoI[]>({
    method: "GET",
    uri: ENDPOINTS.ESTADOS,
    params: servicesUtils.removeNullParamsInFilters(params),
    signal,
  });
  return response.map((ctElemento) => makeEstado(ctElemento));
};

export const getAlcances = async ({ params, signal }: fetchingPropsI) => {
  const response = await sendRequest<AlcanceI[]>({
    method: "GET",
    uri: ENDPOINTS.ALCANCES,
    params: servicesUtils.removeNullParamsInFilters(params),
    signal,
  });
  return response;
};

export interface InformacionGeneralHomeI {
  diseños_curriculares: { registrados: number };
  normativas: { registradas: number };
  usuarios: { registrados: number };
  planes_estudio: { registrados: number };
}

export const getInformacionGeneral = async ({
  params,
  signal,
}: fetchingPropsI) => {
  const response = await sendRequest<InformacionGeneralHomeI>({
    method: "GET",
    uri: ENDPOINTS.INFORMACION_GENERAL,
    params: servicesUtils.removeNullParamsInFilters(params),
    signal,
  });
  return response;
};
